export enum LocationType {
  Origin,
  Destination,
}
